export const useStyles = (theme) => ({
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up(650)]: {
      marginRight: 0,
      display: "flex",
    },
  },
  sectionMobile: {
    display: "none",
    [theme.breakpoints.down(650)]: {
      display: "flex",
    },
  },
  root: {
    color: "#181818",
    minHeight: "89vh",
    backgroundColor: "#eee",
    // overflow: "hidden",
    [theme.breakpoints.down(650)]: {
      minHeight: "auto",
    },
    //width
    "&::-webkit-scrollbar": {
      width: 10,
    },

    //Track
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },

    // Handle
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 10,
      background: "#00acd4",
    },

    // Handle on hover
    "&::-webkit-scrollbar-thumb:hover": {
      background: "grey",
    },
  },
  toolbar: {
    ...theme.mixins.toolbar,
  },
  listitem: {
    "&:hover": { backgroundColor: "#fff", cursor: "pointer" },
  },
});
